/**
 * App-Konstanten
 */

export const LANGUAGES = [
  { code: "en", label: "Englisch" },
  { code: "de", label: "Deutsch (Schweiz)" },
  { code: "fr", label: "Französisch (Schweiz)" },
  { code: "it", label: "Italienisch (Schweiz)" }
];

/**
 * Erstellt einen Schweiz-Hinweis für die Prompt-Generierung
 * @param {string} langCode - Sprachcode (de, fr, it, en)
 * @returns {string} - Schweiz-Hinweis für den Prompt
 */
export function getSwissHint(langCode) {
  const hints = {
    "de": " (Schweizer Hochdeutsch). Verwende in der Übersetzung kein ß, sondern immer ss, wie in der Schweiz üblich.",
    "fr": " (Schweizer Französisch)",
    "it": " (Schweizer Italienisch)",
    "en": ""
  };
  return hints[langCode] || "";
}

/**
 * Findet die Sprachbezeichnung für einen Sprachcode
 * @param {string} langCode - Sprachcode
 * @returns {string} - Sprachbezeichnung
 */
export function getLanguageLabel(langCode) {
  const lang = LANGUAGES.find(l => l.code === langCode);
  return lang ? lang.label : "Englisch";
}
